'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import { DropCountdown } from '@/components/teaser/drop-countdown';
import { SpinningBag } from '@/components/teaser/spinning-bag';
import { IntentPrefetchLink } from '@/components/ui/intent-prefetch-link';
import { DropTickerBar } from './drop-ticker';

/**
 * Drop-campaign homepage hero: the mystery product spinning behind frosted
 * glass (same visual as /drop), a countdown to the drop moment, dual CTAs,
 * and a scrolling ticker bar underneath. Copy, CTAs, timing, and the ticker
 * come from the CMS block.
 */
export function DropHeroBlock(t0) {
  const $ = _c(41);
  const {
    block
  } = t0;
  let t1;
  if ($[0] !== block) {
    t1 = (key, fallback) => {
      const value = block[key];
      return typeof value === "string" && value.trim() ? value.trim() : fallback;
    };
    $[0] = block;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const text = t1;
  let T0;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== block.dropAt || $[3] !== text) {
    const dropAtRaw = typeof block.dropAt === "string" ? Date.parse(block.dropAt) : Number.NaN;
    T0 = DropHero;
    if ($[14] !== text) {
      t2 = text("eyebrow", "Sealed until 8.12");
      $[14] = text;
      $[15] = t2;
    } else {
      t2 = $[15];
    }
    if ($[16] !== text) {
      t3 = text("heading", "Early Is On Time.");
      $[16] = text;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    if ($[18] !== text) {
      t4 = text("subheading", "Something new lands Wednesday. The regular sale goes live at 6:00 PM CT. Sign up for early access and we\u2019ll text you the moment it opens early.");
      $[18] = text;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    if ($[20] !== text) {
      t5 = text("primaryCtaLabel", "Get Early Access");
      $[20] = text;
      $[21] = t5;
    } else {
      t5 = $[21];
    }
    if ($[22] !== text) {
      t6 = text("primaryCtaUrl", "/drop");
      $[22] = text;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    if ($[24] !== text) {
      t7 = text("secondaryCtaLabel", "Shop by Trade");
      $[24] = text;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    if ($[26] !== text) {
      t8 = text("secondaryCtaUrl", "/trades");
      $[26] = text;
      $[27] = t8;
    } else {
      t8 = $[27];
    }
    if ($[28] !== text) {
      t9 = text("tickerText", "Something drops 8.12 \xB7 Early is on time \xB7 Get early access");
      $[28] = text;
      $[29] = t9;
    } else {
      t9 = $[29];
    }
    t10 = Number.isFinite(dropAtRaw) ? dropAtRaw : undefined;
    $[2] = block.dropAt;
    $[3] = text;
    $[4] = T0;
    $[5] = t10;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    T0 = $[4];
    t10 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[30] !== T0 || $[31] !== t10 || $[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t5 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t11 = <T0 eyebrow={t2} heading={t3} subheading={t4} primaryCtaLabel={t5} primaryCtaUrl={t6} secondaryCtaLabel={t7} secondaryCtaUrl={t8} tickerText={t9} dropTargetMs={t10} />;
    $[30] = T0;
    $[31] = t10;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  return t11;
}
interface DropHeroProps {
  eyebrow: string;
  heading: string;
  subheading: string;
  primaryCtaLabel: string;
  primaryCtaUrl: string;
  secondaryCtaLabel: string;
  secondaryCtaUrl: string;
  tickerText: string;
  dropTargetMs?: number;
}
const SEALED_BLUR_PX = 30;
function DropHero(t0) {
  const $ = _c(40);
  const {
    eyebrow,
    heading,
    subheading,
    primaryCtaLabel,
    primaryCtaUrl,
    secondaryCtaLabel,
    secondaryCtaUrl,
    tickerText,
    dropTargetMs
  } = t0;
  const [live, setLive] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setLive(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleLive = t1;
  const blur = live ? 0 : SEALED_BLUR_PX;
  const t2 = `${blur}px`;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      "--teaser-blur": t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = t3 as React.CSSProperties;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      perspective: "1400px",
      perspectiveOrigin: "50% 42%"
    };
    t6 = <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_38%,#2C3033_0%,transparent_56%),radial-gradient(ellipse_at_82%_92%,#232629_0%,transparent_64%),linear-gradient(150deg,#181B1E_0%,#0F1214_100%)]" />;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="teaser-glow-pulse absolute top-[2%] h-[min(70%,540px)] w-[min(110vw,700px)] blur-[10px]" style={{
      background: "radial-gradient(closest-side,rgba(200,164,99,.40),rgba(200,164,99,.09) 52%,transparent 78%)"
    }} />;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="teaser-stage absolute inset-0 z-0 flex items-center justify-center" style={t5}>{t6}{t7}<div className="absolute top-[8%] h-[60%] w-[min(42vw,170px)] blur-[30px]" style={{
        background: "linear-gradient(180deg,transparent,rgba(255,255,255,.30) 32%,rgba(255,255,255,.34) 64%,transparent)"
      }} /><SpinningBag /></div>;
    t9 = <div className="teaser-glass absolute inset-0 z-[1] bg-[linear-gradient(0deg,rgba(0,0,0,.74)_0%,rgba(0,0,0,.32)_48%,rgba(0,0,0,.10)_100%)]" />;
    $[6] = t8;
    $[7] = t9;
  } else {
    t8 = $[6];
    t9 = $[7];
  }
  let t10;
  if ($[8] !== eyebrow) {
    t10 = <div className="mb-4 font-semibold text-[12px] text-white/70 uppercase tracking-[.3em]">{eyebrow}</div>;
    $[8] = eyebrow;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== heading) {
    t11 = <h1 className="max-w-[900px] font-black text-[clamp(40px,9vw,80px)] text-white uppercase leading-[.9] tracking-[-.025em]">{heading}</h1>;
    $[10] = heading;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== subheading) {
    t12 = <p className="mt-[18px] max-w-[520px] text-[clamp(15px,4.2vw,17px)] text-white/80 leading-normal">{subheading}</p>;
    $[12] = subheading;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== dropTargetMs || $[15] !== live) {
    t13 = live ? <div className="mt-7 inline-flex items-center rounded bg-[#B01E24] px-6 py-3.5 font-black text-[clamp(26px,6vw,36px)] text-white uppercase leading-none tracking-[-.02em]">It’s live.</div> : <DropCountdown onLive={handleLive} targetMs={dropTargetMs} />;
    $[14] = dropTargetMs;
    $[15] = live;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== primaryCtaLabel || $[18] !== primaryCtaUrl) {
    t14 = <IntentPrefetchLink href={primaryCtaUrl} className="inline-flex h-[52px] items-center rounded bg-[#B01E24] px-8 font-bold text-[13.5px] text-white uppercase tracking-[.08em] transition-colors hover:bg-[#8E181D] hover:text-white active:bg-[#701316]">{primaryCtaLabel}</IntentPrefetchLink>;
    $[17] = primaryCtaLabel;
    $[18] = primaryCtaUrl;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== secondaryCtaLabel || $[21] !== secondaryCtaUrl) {
    t15 = <IntentPrefetchLink href={secondaryCtaUrl} className="inline-flex h-[52px] items-center rounded border border-white/40 px-8 font-bold text-[13.5px] text-white uppercase tracking-[.08em] transition-colors hover:border-white hover:text-white">{secondaryCtaLabel}</IntentPrefetchLink>;
    $[20] = secondaryCtaLabel;
    $[21] = secondaryCtaUrl;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14 || $[24] !== t15) {
    t16 = <div className="mt-8 flex flex-wrap gap-3">{t14}{t15}</div>;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== t16) {
    t17 = <div className="relative z-[3] mx-auto w-full max-w-[1240px] px-4 pb-[clamp(36px,5vw,64px)] sm:px-6">{t10}{t11}{t12}{t13}{t16}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t17 || $[33] !== t4) {
    t18 = <section className="relative flex min-h-[min(640px,68svh)] flex-col justify-end overflow-hidden bg-[#0F1214] text-white" style={t4}>{t8}{t9}{t17}</section>;
    $[32] = t17;
    $[33] = t4;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== tickerText) {
    t19 = <DropTickerBar text={tickerText} />;
    $[35] = tickerText;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t18 || $[38] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  return t20;
}